// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Categorie.css */

.categorie-page {
  max-width: 600px;
}

.categorie-page h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900, #111827);
  margin: 0 0 1.5rem;
}

/* Form aggiunta */
.categorie-form {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.categorie-input {
  padding: 0.75rem 1rem;
  border: 2px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  font-size: 1rem;
  background: #ffffff;
  color: #111827;
  outline: none;
  transition: border-color 150ms;
  font-family: inherit;
  width: 60%;
}
.categorie-input:focus {
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.categorie-input-tipo {
  min-width: 120px;
  cursor: pointer;
  appearance: auto;
  -webkit-appearance: auto;
  flex: 0 0 auto;
  width: 30%;
}

.categorie-add-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius-md, 0.5rem);
  background: var(--primary-color, #4f46e5);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 150ms;
  width: 10%;
}

.categorie-add-btn:hover {
  background: var(--primary-hover, #4338ca);
}

.categorie-add-btn svg {
  width: 22px;
  height: 22px;
}

/* Messaggi */
.categorie-message {
  padding: 0.75rem 1rem;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.categorie-message.error {
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
}

.categorie-message.success {
  background: #f0fdf4;
  color: #10b981;
  border: 1px solid #bbf7d0;
}

/* Stato vuoto */
.categorie-empty {
  text-align: center;
  padding: 3rem 1rem;
  background: #fff;
  border: 2px dashed var(--gray-300, #d1d5db);
  border-radius: var(--radius-lg, 0.75rem);
}

.empty-icon { font-size: 2.5rem; }
.categorie-empty p { color: var(--gray-500, #6b7280); margin: 0.5rem 0; }
.empty-hint { font-size: 0.85rem; color: var(--gray-400, #9ca3af); }

/* Lista */
.categorie-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Contenitore principale: ora ha bordo, sfondo, padding e border-radius */
.categorie-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;      /* spazio interno unico */
  min-height: 4rem;
  transition: box-shadow 150ms;
  box-sizing: border-box;
  width: 100%;
}
.categorie-item:hover {
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

/* Icona: solo dimensione, niente bordo/padding */
.cat-icon {
  font-size: 1.25rem;
  line-height: 1;
  flex-shrink: 0;
}

/* Nome: occupa lo spazio flessibile */
.cat-name {
  flex: 1 1;
  font-size: 1.1rem;
  font-weight: 500;
  color: #1f2937;
}

/* Badge: larghezza fissa, altezza uguale ai pulsanti, testo centrato */
.cat-tipo-label-badge {
  font-size: 0.75rem;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.2rem 0.4rem;
  border-radius: 999px;
  white-space: nowrap;
  flex: 0 0 90px;              /* larghezza fissa (es. 90px) */
  height: 2rem;                /* stessa altezza dei pulsanti */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* Pulsanti: quadrati 2x2 */
.cat-edit-btn,
.cat-delete-btn {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #9ca3af;
  transition: all 150ms;
  padding: 0;
}
.cat-edit-btn:hover {
  background: #eff6ff;
  color: #3b82f6;
}
.cat-delete-btn:hover {
  background: #fef2f2;
  color: #ef4444;
}

.cat-edit-btn svg,
.cat-delete-btn svg { width: 16px; height: 16px; }

/* Modifica inline */
.categorie-edit-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.categorie-edit-input {
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--primary-color, #4f46e5);
  border-radius: var(--radius-sm, 0.375rem);
  font-size: 0.95rem;
  background: #fff;
  color: #111827;
  outline: none;
  font-family: inherit;
  min-width: 100px;
}
.categorie-edit-input:first-child { flex: 1 1; }

.categorie-edit-tipo {
  min-width: 110px;
  cursor: pointer;
  appearance: auto;
  -webkit-appearance: auto;
}

.categorie-edit-save,
.categorie-edit-cancel {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
}

.categorie-edit-save {
  background: #dcfce7;
  color: #16a34a;
}
.categorie-edit-save:hover {
  background: #bbf7d0;
}

.categorie-edit-cancel {
  background: #fee2e2;
  color: #ef4444;
}
.categorie-edit-cancel:hover {
  background: #fecaca;
}

.categorie-edit-save svg,
.categorie-edit-cancel svg {
  width: 16px;
  height: 16px;
}

.categorie-loading {
  color: var(--gray-500, #6b7280);
  font-size: 1rem;
}

/* Mobile */
@media (max-width: 767px) {
  .categorie-page { max-width: 100%; }
  .categorie-page h2 { font-size: 1.25rem; }
  .categorie-form { flex-direction: row; }

  .categorie-item { padding: 0.85rem 1rem; }
  .cat-name { font-size: 0.95rem; }

  .cat-edit-btn,
  .cat-delete-btn {
    width: 36px;
    height: 36px;
  }
  .cat-edit-btn svg,
  .cat-delete-btn svg { width: 18px; height: 18px; }
}

.category-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  gap: 10px;
  /* oppure usa grid o flex-wrap se vuoi che vadano a capo */
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Categorie.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA,cAAc,iBAAiB,EAAE;AACjC,qBAAqB,+BAA+B,EAAE,gBAAgB,EAAE;AACxE,cAAc,kBAAkB,EAAE,+BAA+B,EAAE;;AAEnE,UAAU;AACV;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB,OAAO,yBAAyB;EACxD,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,sCAAsC;AACxC;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc,eAAe,+BAA+B;EAC5D,YAAY,iBAAiB,gCAAgC;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;sBACsB,WAAW,EAAE,YAAY,EAAE;;AAEjD,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA,oCAAoC,SAAO,EAAE;;AAE7C;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB,eAAe,EAAE;EACnC,qBAAqB,kBAAkB,EAAE;EACzC,kBAAkB,mBAAmB,EAAE;;EAEvC,kBAAkB,qBAAqB,EAAE;EACzC,YAAY,kBAAkB,EAAE;;EAEhC;;IAEE,WAAW;IACX,YAAY;EACd;EACA;wBACsB,WAAW,EAAE,YAAY,EAAE;AACnD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0DAA0D;AAC5D","sourcesContent":["/* Categorie.css */\n\n.categorie-page {\n  max-width: 600px;\n}\n\n.categorie-page h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gray-900, #111827);\n  margin: 0 0 1.5rem;\n}\n\n/* Form aggiunta */\n.categorie-form {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.categorie-input {\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 1rem;\n  background: #ffffff;\n  color: #111827;\n  outline: none;\n  transition: border-color 150ms;\n  font-family: inherit;\n  width: 60%;\n}\n.categorie-input:focus {\n  border-color: var(--primary-color, #4f46e5);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.categorie-input-tipo {\n  min-width: 120px;\n  cursor: pointer;\n  appearance: auto;\n  -webkit-appearance: auto;\n  flex: 0 0 auto;\n  width: 30%;\n}\n\n.categorie-add-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: var(--radius-md, 0.5rem);\n  background: var(--primary-color, #4f46e5);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 150ms;\n  width: 10%;\n}\n\n.categorie-add-btn:hover {\n  background: var(--primary-hover, #4338ca);\n}\n\n.categorie-add-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* Messaggi */\n.categorie-message {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.categorie-message.error {\n  background: #fef2f2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n}\n\n.categorie-message.success {\n  background: #f0fdf4;\n  color: #10b981;\n  border: 1px solid #bbf7d0;\n}\n\n/* Stato vuoto */\n.categorie-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  background: #fff;\n  border: 2px dashed var(--gray-300, #d1d5db);\n  border-radius: var(--radius-lg, 0.75rem);\n}\n\n.empty-icon { font-size: 2.5rem; }\n.categorie-empty p { color: var(--gray-500, #6b7280); margin: 0.5rem 0; }\n.empty-hint { font-size: 0.85rem; color: var(--gray-400, #9ca3af); }\n\n/* Lista */\n.categorie-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Contenitore principale: ora ha bordo, sfondo, padding e border-radius */\n.categorie-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0.75rem 1.25rem;      /* spazio interno unico */\n  min-height: 4rem;\n  transition: box-shadow 150ms;\n  box-sizing: border-box;\n  width: 100%;\n}\n.categorie-item:hover {\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n/* Icona: solo dimensione, niente bordo/padding */\n.cat-icon {\n  font-size: 1.25rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n/* Nome: occupa lo spazio flessibile */\n.cat-name {\n  flex: 1;\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n/* Badge: larghezza fissa, altezza uguale ai pulsanti, testo centrato */\n.cat-tipo-label-badge {\n  font-size: 0.75rem;\n  color: #6b7280;\n  background: #f3f4f6;\n  padding: 0.2rem 0.4rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex: 0 0 90px;              /* larghezza fissa (es. 90px) */\n  height: 2rem;                /* stessa altezza dei pulsanti */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n/* Pulsanti: quadrati 2x2 */\n.cat-edit-btn,\n.cat-delete-btn {\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #9ca3af;\n  transition: all 150ms;\n  padding: 0;\n}\n.cat-edit-btn:hover {\n  background: #eff6ff;\n  color: #3b82f6;\n}\n.cat-delete-btn:hover {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.cat-edit-btn svg,\n.cat-delete-btn svg { width: 16px; height: 16px; }\n\n/* Modifica inline */\n.categorie-edit-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.categorie-edit-input {\n  padding: 0.5rem 0.75rem;\n  border: 2px solid var(--primary-color, #4f46e5);\n  border-radius: var(--radius-sm, 0.375rem);\n  font-size: 0.95rem;\n  background: #fff;\n  color: #111827;\n  outline: none;\n  font-family: inherit;\n  min-width: 100px;\n}\n.categorie-edit-input:first-child { flex: 1; }\n\n.categorie-edit-tipo {\n  min-width: 110px;\n  cursor: pointer;\n  appearance: auto;\n  -webkit-appearance: auto;\n}\n\n.categorie-edit-save,\n.categorie-edit-cancel {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 150ms;\n}\n\n.categorie-edit-save {\n  background: #dcfce7;\n  color: #16a34a;\n}\n.categorie-edit-save:hover {\n  background: #bbf7d0;\n}\n\n.categorie-edit-cancel {\n  background: #fee2e2;\n  color: #ef4444;\n}\n.categorie-edit-cancel:hover {\n  background: #fecaca;\n}\n\n.categorie-edit-save svg,\n.categorie-edit-cancel svg {\n  width: 16px;\n  height: 16px;\n}\n\n.categorie-loading {\n  color: var(--gray-500, #6b7280);\n  font-size: 1rem;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .categorie-page { max-width: 100%; }\n  .categorie-page h2 { font-size: 1.25rem; }\n  .categorie-form { flex-direction: row; }\n\n  .categorie-item { padding: 0.85rem 1rem; }\n  .cat-name { font-size: 0.95rem; }\n\n  .cat-edit-btn,\n  .cat-delete-btn {\n    width: 36px;\n    height: 36px;\n  }\n  .cat-edit-btn svg,\n  .cat-delete-btn svg { width: 18px; height: 18px; }\n}\n\n.category-card {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  background-color: #f9f9f9;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* oppure usa grid o flex-wrap se vuoi che vadano a capo */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
